import http from 'axios'
import config from 'src/config'
import { IContactClient, IContactBase } from 'features/Contacts/types'
import showConfirmModal from 'features/Modal/ConfirmModal/ConfirmModal.action'
import { push } from 'react-router-redux'

export interface IGetContactsInputs {
  cacheKey: string
  page: number
}

export const createContact = (
  contact: IContactBase
): Promise<{ value: { data: IContactClient } }> =>
  ({
    type: 'CONTACTS/CREATE_CONTACT',
    payload: http({
      method: 'POST',
      url: `${config.api.main}/api/v1/contacts`,
      data: contact,
    }),
  } as any)

export const deleteContact = (contactId: string): Promise<{ value: { data: IContactClient } }> =>
  ({
    type: 'CONTACTS/DELETE_CONTACT',
    payload: http({
      method: 'DELETE',
      url: `${config.api.main}/api/v1/contacts/${contactId}`,
    }),
  } as any)

export const confirmDeleteContact = (contactId: string) => dispatch =>
  dispatch(showConfirmModal({ message: 'Are you sure?<br/>This cannot be undone.' }))
    .then(() => dispatch(deleteContact(contactId)))
    .then(() => dispatch(push('/dashboard/contacts')))

export interface ISubscribeContactToFlowInput {
  triggerId: string
  contactId: string
  flowId: string
}

export const subscribeContactToFlow = ({
  triggerId,
  contactId,
  flowId,
}: ISubscribeContactToFlowInput): Promise<{ value: { data: { contact: IContactClient } } }> =>
  ({
    type: 'CONTACTS/SUBSCRIBE_TO_FLOW',
    payload: http({
      method: 'POST',
      url: `${config.api.main}/api/v1/flows/${flowId}/subscribe-contact`,
      data: {
        triggerId,
        contactId,
      },
    }),
    meta: {
      contactId,
    },
  } as any)

export const importContacts = (
  contacts: IContactBase[]
): Promise<{ value: { data: IContactClient[] } }> =>
  ({
    type: 'CONTACTS/IMPORT_CONTACTS',
    payload: http({
      method: 'POST',
      url: `${config.api.main}/api/v1/contacts/import`,
      data: contacts,
      params: {
        updateExisting: 'phoneNumber',
      },
    }),
  } as any)



// WEBPACK FOOTER //
// src/features/Contacts/Contacts.actions.ts